 export default function Style(){
  return (
    <style>
      {`
        @media (max-width: 768px) {
   .res-fs-size {
     font-size: 32px !important;
     line-height: 40px !important;
   }
 }

 @media (max-width: 992px) {
   .res-fs-size {
     font-size: 38px !important;
     line-height: 48px !important;
   }
 }

 @media (max-width: 1534px) {
   .fs-14-16 {
     font-size: 14px !important;
     line-height: 21px !important;
   }

   .res-fs-size {
     font-size: 44px !important;
     line-height: 55px !important;
   }

   .responsiveText {
     font-size: 22px !important;
     line-height: 33px !important;
   }
 }

 @media (min-width: 1543px) {

   .fs-14-16 {
     font-size: 16px !important;
     line-height: 24px !important;
   }

   .responsiveText {
     font-size: 24px !important;
     line-height: 36px !important;
   }

   .res-fs-size {
     font-size: 48px !important;
     line-height: 60px !important;
   }
 }
@media screen and (min-width: 1543px) {
  .fs-res-24 {
    font-size: 24px !important;
    line-height: 30px !important;
    font-weight: 400 !important;

  }

  .fs-res-18 {
    font-size: 18px !important;
    line-height: 18px !important;
    font-weight: 400 !important;

  }

  .fs-res-24-18 {
    font-size: 18px !important;
    line-height: 27px !important;
  }

}

@media screen and (max-width: 1534px) {
  .fs-res-24 {
    font-size: 22px !important;
    line-height: 28px !important;
    font-weight: 400 !important;

  }

  .fs-res-18 {
    font-size: 16px !important;
    line-height: 16px !important;
    font-weight: 400 !important;
  }

  .fs-res-24-18 {
    font-size: 16px !important;
    line-height: 24px !important;
  }

}

@media screen and (max-width: 500px) and (min-width: 450px) {
  .px-mobile-explore {
    padding-left: 13%;
    padding-right: 13%;
  }
    .px-mobile-explore-img {
      height: 324px !important;
    }
  
}


        `}
    </style>
  );
}
